module.exports = __webpack_public_path__ + "3a13b5c8153fef36d62695bcfb5a81b1.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/icons/icon-user.png
// module id = 3212
// module chunks = 69